/* global debounce */
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.disclosure = this.closest('details');
      this.textarea = this.querySelector('textarea[name="note"]');
      this.counterEl = null;

      if (this.disclosure && this.disclosure.matches('.cart-note-disclosure')) {
        this.cartNoteToggle = this.disclosure.querySelector('.js-show-note');
      }

      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.init();
    }

    init() {
      this.debouncedHandleNoteChange = debounce(this.handleNoteChange.bind(this), 300);
      // Save as soon as possible, avoid link-click not providing time to save
      this.addEventListener('input', this.debouncedHandleNoteChange);

      this.setupCounter();
      this.updateCounter();
    }

    getMaxLength() {
      if (!this.textarea) return 254;
      if (typeof this.textarea.maxLength === 'number' && this.textarea.maxLength > 0) return this.textarea.maxLength;

      var attr = this.textarea.getAttribute('maxlength');
      var parsed = parseInt(attr, 10);
      return parsed > 0 ? parsed : 254;
    }

    setupCounter() {
      if (!this.textarea) return;

      var existing = this.querySelector('.cart-note__counter');
      if (existing) {
        this.counterEl = existing;
        this.classList.add('cart-note--has-counter');
        return;
      }

      this.counterEl = document.createElement('span');
      this.counterEl.className = 'cart-note__counter';
      this.counterEl.setAttribute('aria-hidden', 'true');

      this.classList.add('cart-note--has-counter');
      this.appendChild(this.counterEl);
    }

    updateCounter() {
      if (!this.textarea || !this.counterEl) return;
      var max = this.getMaxLength();
      var len = (this.textarea.value || '').length;
      if (len > max) len = max;
      this.counterEl.textContent = String(len) + '/' + String(max);
    }

    clampToMaxLength() {
      if (!this.textarea) return '';
      var max = this.getMaxLength();
      var value = this.textarea.value || '';
      if (value.length > max) {
        value = value.substring(0, max);
        this.textarea.value = value;
      }
      return value;
    }

    handleNoteChange(evt) {
      if (evt && evt.target === this.textarea) {
        this.clampToMaxLength();
        this.updateCounter();
      }

      if (this.cartNoteToggle) {
        var labelValue = this.textarea ? this.textarea.value : (evt && evt.target ? evt.target.value : '');
        var label = labelValue ? theme.strings.editCartNote : theme.strings.addCartNote;
        if (this.cartNoteToggle.textContent !== label) this.cartNoteToggle.textContent = label;
      }

      var valueToSend = this.textarea ? this.textarea.value : (evt && evt.target ? evt.target.value : '');
      var max = this.getMaxLength();
      if (valueToSend && valueToSend.length > max) valueToSend = valueToSend.substring(0, max);

      this.fetchRequestOpts.body = JSON.stringify({ note: valueToSend || '' });
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
    }
  }

  customElements.define('cart-note', CartNote);
}
